import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getCrosslinkStyleClick,
  getCrosslinkStyleHover,
  getCrosslinkStyleSDSelected,
  getCrosslinkStyleSDDeselected,
} from "../style/crosslink";
import {
  distanceAlongFeatureCm,
  findCrosslinkRelationsAt,
} from "../crosslinkRelations";

export function getCrosslinkInteractions(layer, control) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: function (feature) {
      return getCrosslinkStyleClick(feature);
    },
  });
  clickSelect.on("select", function (e) {
    const clickedFeatures = e.target.getFeatures().getArray();
    const position = e.mapBrowserEvent && e.mapBrowserEvent.coordinate;
    if (clickedFeatures.length === 0 || position === undefined) {
      control.set("selectedFeatures", undefined);
      return;
    }
    // Show the crosslink relation(s) under the cursor — not the clicked line's
    // own tags — since that's what's useful for analyzing the SD↔HD match.
    const allFeatures = layer.getSource().getFeatures();
    const relations = [
      ...new Set(
        clickedFeatures.flatMap((feature) =>
          findCrosslinkRelationsAt(
            feature,
            allFeatures,
            distanceAlongFeatureCm(feature, position),
          ),
        ),
      ),
    ];
    control.set(
      "selectedFeatures",
      relations.length > 0 ? relations : undefined,
    );
  });
  clickSelect.on("select", function (e) {
    const allFeatures = layer.getSource().getFeatures();
    e.deselected
      .flatMap((selectedFeature) =>
        findSDFeatures(selectedFeature, allFeatures),
      )
      .forEach((sdFeature) => {
        sdFeature.setStyle(getCrosslinkStyleSDDeselected());
      });
    e.selected
      .flatMap((selectedFeature) =>
        findSDFeatures(selectedFeature, allFeatures),
      )
      .forEach((sdFeature) => {
        sdFeature.setStyle(getCrosslinkStyleSDSelected());
      });
  });
  return [
    clickSelect,
    new Select({
      layers: [layer],
      condition: pointerMove,
      style: function (feature) {
        return getCrosslinkStyleHover(feature);
      },
    }),
  ];
}
function findSDFeatures(selectedFeature, features) {
  return features.filter(
    (feature) =>
      feature.getId() === selectedFeature.get("relation-member-1-id"),
  );
}
